import { SeatType } from "@graphql/sdk";
import { DeviceTicket } from "@state/types";

export function ticketHolderEmail(ticket: DeviceTicket | undefined) {
  return (
    ticket?.email?.trim() ||
    ticket?.user?.email?.trim() ||
    ticket?.buyerInformation?.email?.trim()
  );
}

export function getTicketSeatDetails(ticket: DeviceTicket) {
  const section = ticket.seatSection?.trim() || undefined;
  const label = ticket.seatLabel?.trim();

  if (!label || ticket.seatType === SeatType.GeneralAdmission) {
    return { section, row: undefined, seat: undefined };
  }

  // The category section is independent of the label's section; parents can be rows or tables.
  if (section && label.startsWith(`${section}-`)) {
    const parts = label
      .slice(section.length + 1)
      .split("-")
      .map((part) => part.trim());
    const seat = parts.pop() || undefined;
    return { section, row: parts.join("-") || undefined, seat };
  }

  const parts = label.split("-").map((part) => part.trim());
  const seat = parts.pop() || undefined;
  const row = parts.pop() || undefined;

  return { section: section || parts.join("-") || undefined, row, seat };
}
